<template>
  <div>
    <v-row>
      <v-col cols="12" sm="12" md="2"> </v-col>
      <v-col cols="12" sm="12" md="8">
        <v-card class="mx-auto my-5 mb-10" max-width="1000">
          <v-app-bar flat>
            <span class="headline">{{ $t(formCompData.title) }}</span>
          </v-app-bar>
          <v-card-text>
            <v-container>
              <formComponent
                ref="formComponent"
                :form="formComp"
                v-model="eventForm"
              />
            </v-container>
          </v-card-text>

          <v-card-actions>
            <div class="flex-grow-1"></div>
            <v-btn color="grey" outlined @click="closeform">{{
              $t("general.back")
            }}</v-btn>
            <v-btn color="primary" @click="saveForm(false)" data-cy="saveEvent">
              <div v-if="$route.params.mode === 'new'">
                {{ $t("general.save") }}
              </div>
              <div v-if="$route.params.mode === 'edit'">
                {{ $t("general.saveChanges") }}
              </div>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
      <v-col cols="12" sm="12" md="2"> </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import i18n from "../../i18n";

function getDefaultData() {
  return {
    title: "",
    responsible: "",
    location: "",
    risks: [],
    name: "",
    email: "",
    employeeLanguage: "GER",
    tags: [],
  };
}
import formComponent from "../../components/_utils/formComponent/formComponent.vue";
import { getUniqueId } from "../../components/api/api";
export default {
  components: { formComponent },
  props: ["data"],
  computed: {
    ...mapGetters(["allEmployees", "allEmployeesPending", "allEmployeeTags"]),

    allOtherEmployeeEmails() {
      return this.allEmployees
        .filter((employee) => employee._id !== this.eventForm._id)
        .map((employee) => employee.email);
    },

    formComp() {
      const tagItems = (this.allEmployeeTags || []).map((t) => t.tag);

      return {
        form: [
          [
            {
              cols: 12,
              sm: 6,
              md: 6,
              class: "pb-0 pt-4",
              id: getUniqueId(),
              componentName: "vTextField",
              config: {
                vModel: "name",
                label: "Name",
                dataCy: "name",
                rules: [(v) => !!v || i18n.t("general.fieldNeedsToBeFilled")],
              },
            },
            {
              cols: 12,
              sm: 6,
              md: 6,
              class: "pb-0 pt-4",
              id: getUniqueId(),
              componentName: "vTextField",
              config: {
                vModel: "email",
                label: "Email",
                dataCy: "email",
                rules: [
                  (v) => !!v || i18n.t("general.fieldNeedsToBeFilled"),
                  (v) => /.+@.+\..+/.test(v) || i18n.t("general.emailInvalid"),
                ],
              },
            },
          ],
          [
            {
              cols: 12,
              sm: 12,
              md: 12,
              class: "pb-0 mt-5",
              id: getUniqueId(),
              componentName: "vSelect",
              config: {
                vModel: "employeeLanguage",
                items: [
                  { name: i18n.t("employee.languageGerman"), value: "GER" },
                  { name: i18n.t("employee.languageEnglish"), value: "ENG" },
                ],
                label: i18n.t("employee.language"),
                dataCy: "employeeLanguage",
                rules: [(v) => !!v || i18n.t("general.fieldNeedsToBeFilled")],
              },
            },
          ],
          [
            {
              cols: 12,
              sm: 12,
              md: 12,
              class: "pb-0 mt-5",
              id: getUniqueId(),
              componentName: "vCombobox",
              config: {
                vModel: "tags",
                multiple: true,
                chips: true,
                smallChips: true,
                deletableChips: true,
                clearable: true,
                label: this.$t("employee.tags.label"),
                items: tagItems,
                hideSelected: true,
              },
            },
          ],
        ],
      };
    },
  },
  data: () => ({
    formCompData: {
      title: "employee.addEmployee",
      item: null,
    },
    eventForm: getDefaultData(),
  }),
  async mounted() {
    this.$store.dispatch("getAllEmployeeTags");
    this.switchFormModes(this.$route.params.mode, this.$route.params);
  },
  watch: {
    allEmployeeTags: {
      immediate: true,
      handler() {
        if (!Array.isArray(this.eventForm?.tags) || !this.eventForm.tags.length)
          return;

        const mapped = this.eventForm.tags
          .map((t) => {
            if (t && typeof t === "object" && t.tag) return t.tag;
            if (typeof t === "string") {
              const doc = (this.allEmployeeTags || []).find((x) => x._id === t);
              return doc ? doc.tag : t;
            }
            return "";
          })
          .filter(Boolean);

        this.eventForm = { ...this.eventForm, tags: mapped };
      },
    },
  },
  methods: {
    async switchFormModes(mode, params) {
      switch (mode) {
        case "edit": {
          const item = await this.$store.dispatch(
            "getSingleEmployee",
            params.id,
          );
          this.formCompData.title = this.$t("employee.editEmployee");

          let tags = [];

          if (Array.isArray(item.tags) && item.tags.length) {
            tags = item.tags
              .map((t) => {
                // Case 1: tag is populated { _id, tag }
                if (t && typeof t === "object" && t.tag) {
                  return t.tag;
                }

                // Case 2: tag is an id string -> find it in allEmployeeTags
                if (typeof t === "string") {
                  const doc = (this.allEmployeeTags || []).find(
                    (x) => x._id === t,
                  );
                  return doc ? doc.tag : t; // fallback: show id if we somehow don't know it
                }

                return "";
              })
              .filter(Boolean);
          }

          this.eventForm = {
            ...item,
            tags,
          };
          break;
        }

        case "new":
          this.eventForm = getDefaultData();
          if (this.$route.query && this.$route.query.external) {
            this.eventForm.external = true;
            this.formCompData.title = this.$t("employee.external.create");
          } else {
            this.formCompData.title = this.$t("employee.createEmployee");
          }
          break;
      }
    },
    closeform() {
      this.resetData("new");
    },
    async saveForm(createNew) {
      await this.$nextTick();

      // if (this.allOtherEmployeeEmails.includes(this.eventForm.email)) {
      //   this.$store.dispatch(
      //     "triggerErrorSnackbar",
      //     "Ein Mitarbeiter mit dieser E-Mail Adresse existiert bereits",
      //   );
      //   return;
      // }

      if (this.$refs.formComponent.validateAllFields()) {
        if (this.$route.params.mode === "new") {
          this.$store.dispatch("createEmployee", this.eventForm).then((val) => {
            this.afterUpdateCheck(val, createNew, "new");
          });
        } else {
          this.$store.dispatch("updateEmployee", this.eventForm).then((val) => {
            this.afterUpdateCheck(val, createNew, "edit");
          });
        }
      }
    },

    afterUpdateCheck(val, createNew, mode) {
      if (createNew) {
        //reset contact data to create new one
        this.resetData(mode);
      } else {
        //close form
        this.closeform();
      }
    },
    openDialog(val) {
      this.occupiedDialog.open = true;
      this.occupiedDialog.events = val;
    },
    resetData(mode) {
      this.eventForm = getDefaultData();
      if (mode === "new") {
        this.$refs.formComponent.resetForm();
      }
      this.reloadData();
      this.$router.back();
    },
    reloadData() {
      this.$emit("reloadData");
    },
  },
};
</script>
